function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip-Tool_Desarrollo"
}, React.createElement("rect", {
  width: 48,
  height: 48
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Tool_Desarrollo",
  "data-name": "Tool Desarrollo",
  clipPath: "url(#clip-Tool_Desarrollo)"
}, React.createElement("g", {
  id: "Icono",
  transform: "translate(4 4)",
  fill: "none",
  stroke: "#091832",
  strokeWidth: 2
}, React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 9,
  stroke: "none"
}), React.createElement("rect", {
  x: 1,
  y: 1,
  width: 38,
  height: 38,
  rx: 8,
  fill: "none"
})), React.createElement("g", {
  id: "Group_1",
  "data-name": "Group 1",
  transform: "translate(-439.898 -325.982) rotate(-45)"
}, React.createElement("g", {
  id: "Rectangle_50",
  "data-name": "Rectangle 50",
  transform: "translate(75.596 575.867)",
  fill: "none",
  stroke: "#091832",
  strokeLinejoin: "round",
  strokeWidth: 1.7
}, React.createElement("rect", {
  width: 17.59,
  height: 10.261,
  stroke: "none"
}), React.createElement("rect", {
  x: 0.85,
  y: 0.85,
  width: 15.89,
  height: 8.561,
  fill: "none"
})), React.createElement("g", {
  id: "Polygon_1",
  "data-name": "Polygon 1",
  transform: "translate(69 586.494) rotate(-90)",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, React.createElement("path", {
  d: "M4.671,1.212a1,1,0,0,1,1.652,0L9.928,6.5A1,1,0,0,1,9.1,8.062H1.892A1,1,0,0,1,1.066,6.5Z",
  stroke: "none"
}), React.createElement("path", {
  d: "M 5.496961116790771 3.017731666564941 L 3.216639041900635 6.362204551696777 L 7.777278900146484 6.362204551696777 L 5.496961116790771 3.017731666564941 M 5.496958255767822 0.775139331817627 C 5.810830593109131 0.775139331817627 6.124703407287598 0.9206943511962891 6.323188304901123 1.211804389953613 L 9.928008079528809 6.498874664306641 C 10.3805980682373 7.162674427032471 9.905198097229004 8.062204360961914 9.101778030395508 8.062204360961914 L 1.892138481140137 8.062204360961914 C 1.088718414306641 8.062204360961914 0.6133184432983398 7.162674427032471 1.065908432006836 6.498874664306641 L 4.670728206634521 1.211804389953613 C 4.869213104248047 0.9206943511962891 5.183085918426514 0.775139331817627 5.496958255767822 0.775139331817627 Z",
  stroke: "none",
  fill: "#091832"
})), React.createElement("line", {
  id: "Line_17",
  "data-name": "Line 17",
  y2: 8.795,
  transform: "translate(88.423 576.966)",
  fill: "none",
  stroke: "#091832",
  strokeWidth: 1.7
})), React.createElement("line", {
  id: "Line_11",
  "data-name": "Line 11",
  x2: 21,
  transform: "translate(13.5 13.5)",
  fill: "none",
  stroke: "#091832",
  strokeLinecap: "round",
  strokeWidth: 2
}), React.createElement("line", {
  id: "Line_12",
  "data-name": "Line 12",
  x2: 15,
  transform: "translate(13.5 20.5)",
  fill: "none",
  stroke: "#091832",
  strokeLinecap: "round",
  strokeWidth: 2
}), React.createElement("line", {
  id: "Line_13",
  "data-name": "Line 13",
  x2: 8,
  transform: "translate(13.5 27.5)",
  fill: "none",
  stroke: "#091832",
  strokeLinecap: "round",
  strokeWidth: 2
}), React.createElement("line", {
  id: "Line_14",
  "data-name": "Line 14",
  x2: 3,
  transform: "translate(13.5 34.5)",
  fill: "none",
  stroke: "#091832",
  strokeLinecap: "round",
  strokeWidth: 2
}));

var SvgToolDesarrollo = function SvgToolDesarrollo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgToolDesarrollo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Tool Desarrollo.0b923342.svg";
export { ForwardRef as ReactComponent };